import {
  Box,
  Button,
  Checkbox,
  Collapse,
  Flex,
  Input,
  InputGroup,
  InputLeftElement,
  List,
  ListItem,
  Text,
  Icon,
  HStack,
} from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import { useStores } from "../../store/store_context";
import { useEffect, useState } from "react";
import { FiChevronDown, FiChevronUp, FiSearch, FiX } from "react-icons/fi";

const ModalSelectMonth = observer(() => {
  const { pageStore } = useStores();
  const [monthOpen, setMonthOpen] = useState(false);
  const [yearOpen, setYearOpen] = useState(false);
  const [monthSearchTerm, setMonthSearchTerm] = useState("");
  const [yearSearchTerm, setYearSearchTerm] = useState("");
  const [selectedMonths, setSelectedMonths] = useState([]);
  const [selectedYears, setSelectedYears] = useState([]);

  useEffect(() => {
    pageStore.updateSelectedPeriodMonth("");
    pageStore.updateSelectedPeriodYear("");
  }, []);

  const filteredMonths = (pageStore.all_periods?.mouths || [])
    .filter(
      (item) =>
        item?.UF_CRM_1490281786 !== "" &&
        item?.UF_CRM_1490281786 !== "Сделка не закрыта"
    )
    .sort((a, b) => a.UF_CRM_1490281786.localeCompare(b.UF_CRM_1490281786));

  const filteredYears = (pageStore.all_periods?.years || [])
    .filter(
      (item) =>
        item?.UF_CRM_1490282792 !== "" &&
        item?.UF_CRM_1490282792 !== "Сделка не закрыта"
    )
    .sort((a, b) => b.UF_CRM_1490282792.localeCompare(a.UF_CRM_1490282792));

  const handleSelectMonth = (monthValue) => {
    setSelectedMonths((prev) =>
      prev.includes(monthValue)
        ? prev.filter((val) => val !== monthValue)
        : [...prev, monthValue]
    );
  };

  const handleSelectYear = (yearValue) => {
    setSelectedYears((prev) =>
      prev.includes(yearValue)
        ? prev.filter((val) => val !== yearValue)
        : [...prev, yearValue]
    );
  };

  const handleSelectAllMonths = () => {
    if (selectedMonths.length === filteredMonths.length) {
      setSelectedMonths([]);
    } else {
      setSelectedMonths(filteredMonths.map((item) => item?.UF_CRM_1490281786));
    }
  };

  const handleSelectAllYears = () => {
    if (selectedYears.length === filteredYears.length) {
      setSelectedYears([]);
    } else {
      setSelectedYears(filteredYears.map((item) => item?.UF_CRM_1490282792));
    }
  };

  const handleSaveMonths = () => {
    pageStore.updateSelectedPeriodMonth(selectedMonths);
    setMonthOpen(false);
  };

  const handleSaveYears = () => {
    pageStore.updateSelectedPeriodYear(selectedYears);
    setYearOpen(false);
  };

  const handleResetMonths = () => {
    setSelectedMonths([]);
    pageStore.updateSelectedPeriodMonth([]);
  };

  const handleResetYears = () => {
    setSelectedYears([]);
    pageStore.updateSelectedPeriodYear([]);
  };

  const toggleMonthDropdown = () => {
    setMonthOpen(!monthOpen);
    if (yearOpen) setYearOpen(false);
  };

  const toggleYearDropdown = () => {
    setYearOpen(!yearOpen);
    if (monthOpen) setMonthOpen(false);
  };

  return (
    <HStack>
      {/* Месяцы */}
      <Box position="relative" width="300px">
        <Button
          w="100%"
          borderRadius="10px"
          bg="rgb(51, 51, 51)"
          color="myColor.white"
          _hover={{
            bg: "rgb(27, 26, 26)",
            color: "myColor.green",
          }}
          rightIcon={<Icon as={monthOpen ? FiChevronUp : FiChevronDown} />}
          onClick={toggleMonthDropdown}
          justifyContent="space-between"
        >
          {selectedMonths.length > 0
            ? `Месяцы: ${selectedMonths.length}`
            : "Выберите месяцы"}
        </Button>

        <Collapse in={monthOpen} animateOpacity>
          <Box
            mt={2}
            p={4}
            bg="#1e1e1e"
            borderRadius="md"
            boxShadow="lg"
            zIndex="dropdown"
            position="absolute"
            width="100%"
          >
            <InputGroup mb={3}>
              <InputLeftElement pointerEvents="none">
                <Icon as={FiSearch} color="gray.400" />
              </InputLeftElement>
              <Input
                placeholder="Поиск по месяцам"
                value={monthSearchTerm}
                onChange={(e) => setMonthSearchTerm(e.target.value)}
                color="myColor.white"
                _placeholder={{ color: "gray.400" }}
              />
            </InputGroup>

            <Box maxH="300px" overflowY="auto" mb={3}>
              <List spacing={2}>
                <ListItem
                  p={1}
                  borderRadius="md"
                  _hover={{ bg: "rgba(255, 255, 255, 0.1)" }}
                >
                  <Checkbox
                    isChecked={
                      selectedMonths.length > 0 &&
                      selectedMonths.length === filteredMonths.length
                    }
                    isIndeterminate={
                      selectedMonths.length > 0 &&
                      selectedMonths.length < filteredMonths.length
                    }
                    onChange={handleSelectAllMonths}
                    colorScheme="blue"
                    color="myColor.white"
                  >
                    <Text as="span" fontWeight="bold">
                      Выбрать все
                    </Text>
                  </Checkbox>
                </ListItem>

                {filteredMonths
                  .filter((item) =>
                    item.UF_CRM_1490281786.toLowerCase().includes(
                      monthSearchTerm.toLowerCase()
                    )
                  )
                  .map((item, index) => (
                    <ListItem
                      key={index}
                      p={1}
                      borderRadius="md"
                      _hover={{ bg: "rgba(255, 255, 255, 0.1)" }}
                    >
                      <Checkbox
                        isChecked={selectedMonths.includes(
                          item.UF_CRM_1490281786
                        )}
                        onChange={() =>
                          handleSelectMonth(item.UF_CRM_1490281786)
                        }
                        colorScheme="blue"
                        color="myColor.white"
                      >
                        {item.UF_CRM_1490281786.split("_")[1]}
                      </Checkbox>
                    </ListItem>
                  ))}
              </List>
            </Box>

            <Flex justify="space-between">
              <Button
                leftIcon={<Icon as={FiX} />}
                variant="ghost"
                color="gray.400"
                onClick={handleResetMonths}
              >
                Сбросить
              </Button>
              <Button
                bg="rgb(51, 51, 51)"
                color="myColor.white"
                _hover={{
                  bg: "rgb(27, 26, 26)",
                  color: "myColor.green",
                }}
                onClick={handleSaveMonths}
              >
                Применить
              </Button>
            </Flex>
          </Box>
        </Collapse>
      </Box>

      {/* Годы */}
      <Box position="relative" width="300px">
        <Button
          w="100%"
          borderRadius="10px"
          bg="rgb(51, 51, 51)"
          color="myColor.white"
          _hover={{
            bg: "rgb(27, 26, 26)",
            color: "myColor.green",
          }}
          rightIcon={<Icon as={yearOpen ? FiChevronUp : FiChevronDown} />}
          onClick={toggleYearDropdown}
          justifyContent="space-between"
        >
          {selectedYears.length > 0
            ? `Годы: ${selectedYears.length}`
            : "Выберите годы"}
        </Button>

        <Collapse in={yearOpen} animateOpacity>
          <Box
            mt={2}
            p={4}
            bg="#1e1e1e"
            borderRadius="md"
            boxShadow="lg"
            zIndex="dropdown"
            position="absolute"
            width="100%"
          >
            <InputGroup mb={3}>
              <InputLeftElement pointerEvents="none">
                <Icon as={FiSearch} color="gray.400" />
              </InputLeftElement>
              <Input
                placeholder="Поиск по годам"
                value={yearSearchTerm}
                onChange={(e) => setYearSearchTerm(e.target.value)}
                color="myColor.white"
                _placeholder={{ color: "gray.400" }}
              />
            </InputGroup>

            <Box maxH="300px" overflowY="auto" mb={3}>
              <List spacing={2}>
                <ListItem
                  p={1}
                  borderRadius="md"
                  _hover={{ bg: "rgba(255, 255, 255, 0.1)" }}
                >
                  <Checkbox
                    isChecked={
                      selectedYears.length > 0 &&
                      selectedYears.length === filteredYears.length
                    }
                    isIndeterminate={
                      selectedYears.length > 0 &&
                      selectedYears.length < filteredYears.length
                    }
                    onChange={handleSelectAllYears}
                    colorScheme="blue"
                    color="myColor.white"
                  >
                    <Text as="span" fontWeight="bold">
                      Выбрать все
                    </Text>
                  </Checkbox>
                </ListItem>

                {filteredYears
                  .filter((item) =>
                    item.UF_CRM_1490282792.toLowerCase().includes(
                      yearSearchTerm.toLowerCase()
                    )
                  )
                  .map((item, index) => (
                    <ListItem
                      key={index}
                      p={1}
                      borderRadius="md"
                      _hover={{ bg: "rgba(255, 255, 255, 0.1)" }}
                    >
                      <Checkbox
                        isChecked={selectedYears.includes(
                          item.UF_CRM_1490282792
                        )}
                        onChange={() =>
                          handleSelectYear(item.UF_CRM_1490282792)
                        }
                        colorScheme="blue"
                        color="myColor.white"
                      >
                        {item.UF_CRM_1490282792}
                      </Checkbox>
                    </ListItem>
                  ))}
              </List>
            </Box>

            <Flex justify="space-between">
              <Button
                leftIcon={<Icon as={FiX} />}
                variant="ghost"
                color="gray.400"
                onClick={handleResetYears}
              >
                Сбросить
              </Button>
              <Button
                bg="rgb(51, 51, 51)"
                color="myColor.white"
                _hover={{
                  bg: "rgb(27, 26, 26)",
                  color: "myColor.green",
                }}
                onClick={handleSaveYears}
              >
                Применить
              </Button>
            </Flex>
          </Box>
        </Collapse>
      </Box>
    </HStack>
  );
});

export default ModalSelectMonth;
